export default __webpack_public_path__ + "static/common-app-logo-new-caa2e5a827b3660a7e3ea57d35962e8c.svg";